import A from '../actions/endorsementsActions';
import { RSAA } from 'redux-api-middleware';
import { ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

export const
getEndorsementsData = (page, pageSize, sort, column, search) => ({ [RSAA]: {
    method: 'POST',
    endpoint: ssSessionUtils.isDod() ? `afsp-dod/endorsee/org/${window.session.jwtSession.PRIMARY_ORG_ID}` :'/afsp-dod/endorsee/school',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({orgIds: window.session.jwtSession.ORGS, page: page, pageSize: pageSize, sort: sort, column: column, search: search}),
    types: [
        A.ENDORSEMENTS_DATA_REQUEST_PENDING,
        A.ENDORSEMENTS_DATA_REQUEST_SUCCESS,
        A.ENDORSEMENTS_DATA_REQUEST_FAILURE
    ]
}}),
handleOnChangePaging = (page, pageSize, sort, column) => {
    return {type: A.ENDORSEMENTS_PAGING_CHANGE, pagingData: {page: page, sort: sort, column: column, pageSize: pageSize}};
},
addSearchText = (text) => {
    return {type: A.ENDORSEMENTS_SEARCH_ADD, text};
}